import React from "react";
import '../home-2/Programs.css';
import bannerImage from '../../Images/Banner/university.png';

const Sec1 = () => {
    return (
        <div className="position-relative text-white">
            {/* Background Image */}
            <img
                src={bannerImage}
                alt="Banner"
                className="img-fluid w-100"
                style={{ objectFit: "cover", height: "450px" }}
                loading="lazy"
            />

            {/* Dark Overlay with Opacity */}
            <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 1 }}
            ></div>

            {/* Overlay Text */}
            <div
                className="position-absolute top-50 start-50 translate-middle text-center px-3"
                style={{ zIndex: 2 }}
            >
                <h5
                    className="fw-bold mb-2"
                    style={{ fontFamily: "'Jost', sans-serif", color: "#fff" }}
                >
                    <span style={{ color: "#c5135d" }}>About</span>
                </h5>
                <h1 className="fw-bold mb-3" style={{ fontSize: "2.5rem", color: "#fff" }}>
                    Placements
                </h1>
                <hr
                    className="mx-auto"
                    style={{
                        width: "80%",
                        height: "2px",
                        backgroundColor: "#fff",
                        opacity: 1,
                    }}
                />
            </div>
        </div>
    );
};

export default Sec1;
